export const COUNTRIES = {
    CZ: 'CZ',
    SK: 'SK',
}
